import React, { useEffect } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { UploadProps } from 'antd';
import { Input, Select, Button, message, Upload } from 'antd';
import { customFieldValidator } from '../../../utils';
import FilledButton from '../../../component/FilledButton';
import { useState } from 'react';
import { applicationRules, timeZone } from '../json';
import BtnLoader from '../../../layout/BtnLoader';
import Doc from '../../../assets/images/doc.png';
import { ReactComponent as DeleteIcon } from '../../../assets/images/delete.svg';
import { useSelector } from 'react-redux';

function CourseInformation({
  courseInfo,
  form,
  Form,
  onStepFinish,
  handleUpload,
  interestFile,
  gradesFile,
  gradeLoader,
  interestLoader,
  handleDeleteUploads,
  applicationLoading,
  dispatch
}) {
  const userData = useSelector((state) => state.ApplicationModel.applicatio_id);
  const { TextArea } = Input;
  const { Option } = Select;

  // useEffect(()=>{
  //   dispatch.ApplicationModel.preClgEvent({
  //     ["event"]: 'Application Step 2',
  //     email:userData.email,
  //     user_id:userData._id,
  //     course_id:userData.course_id
  //   });
  // },[userData])

  function isImage(url) {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  const getCard = (link) => {
    if (isImage(link)) {
      return <img alt='file' src={link} />;
    } else {
      return (
        <div className='doc-placeholder'>
          <span>{link.split('/').slice(-1).join()}</span>
        </div>
      );
    }
  };

  const handleBeforeUpload = (file) => {
    if (
      !file.type.match(/jpg|jpeg|png|webp|avif|gif|svg|pdf|doc|docx|docm|wps/g)
    ) {
      window.alert('Please upload a valid image or doc files only');
      return Upload.LIST_IGNORE;
    }
  };

  return (
    <div>
      <Form
        form={form}
        name='register'
        onFinish={(values) => onStepFinish(values, 2)}
        className='course-information'
        scrollToFirstError
      >
        <Form.Item
          name={['course_information', 'select_timezone']}
          rules={applicationRules.select_timezone}
          className='form_group'
          label='While taking the course, what is the time zone you will be based in?'
        >
          <Select placeholder='Please select a Timezone'>
            {timeZone.map((data) => {
              return <Option value={data}>{data}</Option>;
            })}
          </Select>
        </Form.Item>
        <Form.Item
          name={['course_information', 'about_yourself']}
          rules={applicationRules.about_yourself}
          className='form_group'
          label={
            '  Tell us a little about yourself. Why do you want to take this course? Write a response of up to 2000 characters'
          }
        >
          <TextArea name='about_yourself' rows={4} maxLength={2000} />
        </Form.Item>
        <Form.Item
          name={['course_information', 'most_recently_completed']}
          rules={applicationRules.most_recently_completed}
          label={'Upload an unofficial transcript from your high school reflecting your most recently completed academic semester grades.'}
          className='form_group'
        >
          <div className='upload_wrapper'>
            <Upload
              accept='application/msword, application/pdf, image/*'
              showUploadList={false}
              beforeUpload={handleBeforeUpload}
              customRequest={(e) => handleUpload(e, 'grades')}
            >
              {gradesFile ? (
                <div className='image-placeholder'>{getCard(gradesFile)}</div>
              ) : gradeLoader ? (
                <div className='post-loader'>
                  <BtnLoader />
                </div>
              ) : (
                <Button icon={<PlusOutlined />}></Button>
              )}
            </Upload>
            {gradesFile && (
              <DeleteIcon
                onClick={() => handleDeleteUploads('grades')}
                className='del-icon'
              />
            )}
          </div>
        </Form.Item>
        <Form.Item
          name={['course_information', 'self_document']}
          className='form_group'
        >
          <label>
            Upload a writing sample, photos or other media that will tell us
            more about yourself and your interests. (Optional)
          </label>
          <div className='upload_wrapper'>
            <Upload
              accept='application/msword, application/pdf, image/*'
              showUploadList={false}
              beforeUpload={handleBeforeUpload}
              customRequest={(e) => handleUpload(e, 'interst')}
            >
              {interestFile ? (
                <div className='image-placeholder'>{getCard(interestFile)}</div>
              ) : interestLoader ? (
                <div className='post-loader'>
                  <BtnLoader />
                </div>
              ) : (
                <Button icon={<PlusOutlined />}></Button>
              )}
            </Upload>
            {interestFile && (
              <DeleteIcon
                onClick={() => handleDeleteUploads('interst')}
                className='del-icon'
              />
            )}
          </div>
        </Form.Item>
        <Form.Item
          label={
            'You can also share a link to a social account (youtube, vimeo, etc) that contains content you’ve created. (Optional)'
          }
          name={['course_information', 'url']}
          className='form_group'
          rules={applicationRules.url}
        >
          <Input autoComplete={'off'} className='form_control' name={'url'} />
        </Form.Item>
        <div className='form_group pt_1 pb_2'>
          <FilledButton
            type='submit'
            value='Continue'
            className='btn_primary ml_1'
            loading={applicationLoading}
          />
        </div>
      </Form>
    </div>
  );
}

export default CourseInformation;
